import Vue from 'vue'
import VueRouter from 'vue-router'
import HomeRock from '../views/HomeRock.vue'

Vue.use(VueRouter)

const routes = [{
        path: '/',
        name: 'HomeRock',
        component: HomeRock
    },
    {
        path: '/HomeRock',
        name: 'HomeRock',
        component: HomeRock
    },
    {
      path: '/ArtistasRock',
      name: 'ArtistasRock',
      component: () =>
            import ('../views/ArtistasRock.vue')
    },
    {
        path: '/FestivalsRock',
        name: 'FestivalsRock',
        component: () =>
              import ('../views/FestivalsRock.vue')
    },
    {
        path: '/NovetatsRock',
        name: 'NovetatsRock',
        component: () =>
              import ('../views/NovetatsRock.vue')
    },
    {
        path: '/QuiSomRock',
        name: 'QuiSomRock',
        component: () =>
              import ('../views/QuiSomRock.vue')
    },  
    {
        path: '/AdtrRock',
        name: 'AdtrRock',
        component: () =>
              import ('../views/AdtrRock.vue')
    },
    {
        path: '/ArchitectsRock',
        name: 'ArchitectsRock',
        component: () =>
            import ('../views/ArchitectsRock.vue')
    },
    {
        path: '/BmthRock',
        name: 'BmthRock',
        component: () =>
            import ('../views/BmthRock.vue')
    },
    {
        path: '/DaughtryRock',
        name: 'DaughtryRock',
        component: () =>
            import ('../views/DaughtryRock.vue')
    },
    {
        path: '/ElectricCallboyRock',
        name: 'ElectricCallboyRock',
        component: () =>
            import ('../views/ElectricCallboyRock.vue')
    },
    {
        path: '/FallingInReverseRock',
        name: 'FallingInReverseRock',
        component: () =>
            import ('../views/FallingInReverseRock.vue')
    },
    {
        path: '/FitForAKingRock',
        name: 'FitForAKingRock',
        component: () =>
            import ('../views/FitForAKingRock.vue')
    },
    {
        path: '/NickelbackRock',
        name: 'NickelbackRock',
        component: () =>
            import ('../views/NickelbackRock.vue')
    },
    {
        path: '/VolbeatRock',
        name: 'VolbeatRock',
        component: () =>
            import ('../views/VolbeatRock.vue')
    },
    {
        path: '/AzkenaRock',
        name: 'AzkenaRock',
        component: () =>
            import ('../views/AzkenaRock.vue')
    },
    {
        path: '/FujiRock',
        name: 'FujiRock',
        component: () =>
            import ('../views/FujiRock.vue')
    },
    {
        path: '/GraspopRock',
        name: 'GraspopRock',
        component: () =>
            import ('../views/GraspopRock.vue')
    },
    {
        path: '/DiscograficasRock',
        name: 'DiscograficasRock',
        component: () =>
            import ('../views/DiscograficasRock.vue')
    },
    {
        path: '/HellRock',
        name: 'HellRock',
        component: () =>
            import ('../views/HellRock.vue')
    },
    {
        path: '/NovaRock',
        name: 'NovaRock',
        component: () =>
            import ('../views/NovaRock.vue')
    },
    {
        path: '/MexicoRock',
        name: 'MexicoRock',
        component: () =>
            import ('../views/MexicoRock.vue')
    },
    {
        path: '/ResurrectionRock',
        name: 'ResurrectionRock',
        component: () =>
            import ('../views/ResurrectionRock.vue')
    },
    {
        path: '/WerchterRock',
        name: 'WerchterRock',
        component: () =>
            import ('../views/WerchterRock.vue')
    },
    {
        path: '/RoskildeRock',
        name: 'RoskildeRock',
        component: () =>
            import ('../views/RoskildeRock.vue')
    }





]

const router = new VueRouter({
    mode: "history",
    base: '/rock_records/',
    routes
})

export default router